import React, { useState, useEffect } from "react";
import { updateItem, getData, searchTable } from "../Tools/helpers";
import Alert from "@mui/material/Alert";
import { PageTitle, SearchInput } from "../components/PageHeader";

import TableHistoryCustom from "../components/TableHistoryCustom";
import DialogCustom from "../components/DialogCustom";

const RequestPaymentTransfer = () => {
  const currentYear = new Date().getFullYear();
  const [dataTable, setDataTable] = useState([]);
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const yearOptions = Array.from({ length: currentYear - 2022 }, (_, i) => currentYear - i);
  const [itemApproved, setItemApproved] = useState(0);
  const [isDialog, setIsDialog] = useState(false);
  const [isDialog2, setIsDialog2] = useState(false);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const FieldsCustomTable = [
    { name: "code", label: "Código" },
    { name: "name_student", label: "Nombre" },
    { name: "campus", label: "Campus" },
    { name: "description", label: "Concepto" },
    { name: "month", label: "Mes" },
    { name: "transfer_date", label: "Fecha" },
    { name: "total", label: "Total" },
    { name: "method_payment", label: "Forma de pago" },
    { name: "status_description", label: "Estatus" },
    { name: "approved_by", label: "Apropado por" },
    { name: "approved_date", label: "Fecha aprobación" },
    { name: "status", label: "" },
  ];

  const [loading, setLoading] = useState(false);

  const getPayments = async (year = selectedYear) => {
    setLoading(true);
    const route = `PaymentTransfer?year=${year}`;
    const send = await getData(route);
    if (send.code === 200) {
      setListSearch(send.data);
      setDataTable(send.data);
    }
    setLoading(false);
  };

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value);
    setSelectedYear(year);
    setFieldSearch("");
    getPayments(year);
  };

    //BUSQUEDA
    const [fieldSearch, setFieldSearch] = useState("");
    const [listSearch, setListSearch] = useState([]);
    const [activeTab, setActiveTab] = useState("Pendiente");

    const setStateSearch = async (e) => {
      await setFieldSearch(e.target.value);
      const resulData = await searchTable(dataTable, e.target.value, "name_student", "code");
      setListSearch(resulData);
    };

    const TABS = [
      { key: "Pendiente",  label: "Pendiente" },
      { key: "Aprobado",   label: "Aprobado"  },
      { key: "Declinado",  label: "Declinado" },
      { key: "all",        label: "Todos"     },
    ];

    const tabCount = (key) =>
      key === "all"
        ? listSearch.length
        : listSearch.filter(r => r.status_description === key).length;

    const filteredData = activeTab === "all"
      ? listSearch
      : listSearch.filter(r => r.status_description === activeTab);

  const approvedPayment = async (option, statusPayment) => {
    setMessage({
      status: false,
      message: "",
      label: "",
    });

    if(statusPayment === 0){
      setIsDialog(false);
    }else{
      setIsDialog2(false);
    }

    if (!option) {
      return;
    }
    setMessage({
      status: true,
      message: "Cancelando...",
      label: "info",
    });

    const dataStatus = {
      status: statusPayment,
      status_description: statusPayment === 0 ? "Aprobado" : "Declinado",
    };

    const route = "ApprovePaymentFourMonth";
    const send = await updateItem(`${route}/${itemApproved.id}`, dataStatus);
    if (send.code === 200) {
      setMessage({
        status: true,
        message: statusPayment === 0 ? "Se ha aprobado correctamente" : "Se ha declinado, el alumno debe reenviar el comprobante",
        label: "success",
      });
      getPayments();
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  };

  const downloadEvidence = async (item) => {
    const route = "DownloadEvidence";
    const send = await getData(`${route}/${item.id}`);
    if (send.code === 200) {
      var a = document.createElement("a");
      a.href = send.data;
      a.download = `${item.code}_${item.name_student}_${item.month}`;
      a.click();
    }
  };

  const activeDialog = (row, action) => {
    setItemApproved(row);
    if(action === 'aprobar'){
      setIsDialog(true);
      return;
    }
    setIsDialog2(true);
  };

  useEffect(() => {
    getPayments();
  }, []);

  return (
    <div className="flex-1">
      <DialogCustom
        open={isDialog}
        message={{ title: "Aprobar", message: "¿Desea aprobar el pago?" }}
        action={approvedPayment}
        statusPayment = {0}
      />
      <DialogCustom
        open={isDialog2}
        message={{ title: "Declinar", message: "¿Desea declinar el pago?" }}
        action={approvedPayment}
        statusPayment = {2}
      />
      <div className="flex-1 mb-10">
        <PageTitle>{ userData.abbreviation === 'cajero' ? 'Historial de últimos pagos' : 'Validar pagos Transferencia/Deposito' }</PageTitle>
        {message.status ? (
          <Alert className="mt-2" severity={message.label}>
            {message.message}
          </Alert>
        ) : (
          ""
        )}
        <div className="flex gap-4 items-center mb-10">
          <SearchInput
            value={fieldSearch}
            onChange={setStateSearch}
            placeholder="Buscar por nombre o CURP..."
            style={{ maxWidth: '320px', flex: 1 }}
          />
          <div>
            <select
              value={selectedYear}
              onChange={handleYearChange}
              style={{
                border: '1px solid #d1d5db', borderRadius: '7px', padding: '8px 12px',
                fontSize: '0.82rem', backgroundColor: '#fff',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)', outline: 'none',
              }}
            >
              {yearOptions.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex border-b mb-4">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`py-2 px-4 font-medium text-sm ${activeTab === tab.key ? 'text-red-600 border-b-2 border-red-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              {tab.label}
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
                {tabCount(tab.key)}
              </span>
            </button>
          ))}
        </div>

        {loading && (
          <div className="flex items-center gap-2 py-4 text-gray-500 text-sm">
            <i className="fa-solid fa-spinner fa-spin"></i>
            Cargando...
          </div>
        )}

        <TableHistoryCustom
          fields={FieldsCustomTable}
          data={filteredData}
          actionType={userData.abbreviation === 'cajero' ? ["downloadEvidence"] : ["approve", "downloadEvidence"]}
          action={activeDialog}
          action2={downloadEvidence}
        />
      </div>
    </div>
  );
};

export default RequestPaymentTransfer;
